import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>Got lost? Don't worry, it happens to the best of us!</p>
<p>Welcome to the endless maze of the internet – where every link is an adventure, and every click holds a new surprise!</p>

        <a
          className="App-link"
          href="https://theuselessweb.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          The Useless Web
        </a>
      </header>
    </div>
  );
}

export default App;
